// extracted by mini-css-extract-plugin
export default {"wrapper":"BurgerIcon_wrapper__A+q+H","burger":"BurgerIcon_burger__sLKOU","dark":"BurgerIcon_dark__ChwqB","light":"BurgerIcon_light__NzYqs","cross":"BurgerIcon_cross__CDipq"};